function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.2 15.4c.3-.8.5-1.8.6-2.8h2.4c-.6 1.2-1.7 2.2-3 2.8m-3 .4c-.2-.3-.6-1.5-.9-3.2h3.3c-.3 1.7-.7 2.9-.9 3.2-.2 0-.5.1-.7.1-.3-.1-.5-.1-.8-.1m-4.4-3.2h2.4c.1 1 .4 2 .6 2.8-1.3-.6-2.4-1.6-3-2.8m3-8c-.2.8-.5 1.8-.6 2.8H4.8c.6-1.2 1.7-2.3 3-2.8m2.9-.4c.1.3.6 1.6.9 3.2H8.4c.3-1.7.7-2.9.9-3.2.2 0 .5-.1.7-.1.2.1.5.1.7.1M8.2 10c0-.5 0-.9.1-1.3h3.5c0 .4.1.9.1 1.3s0 .9-.1 1.3H8.2V10m-4 0c0-.5.1-.9.2-1.3H7c0 .5-.1 1-.1 1.3 0 .4 0 .8.1 1.3H4.3c-.1-.4-.1-.8-.1-1.3m11.6 0c0 .5-.1.9-.2 1.3H13c0-.5.1-.9.1-1.3s0-.8-.1-1.3h2.7c.1.4.1.8.1 1.3m-.6-2.6h-2.4c-.2-1-.4-2-.7-2.8 1.4.5 2.5 1.6 3.1 2.8M10 2.9c-3.9 0-7.1 3.2-7.1 7.1s3.2 7.1 7.1 7.1 7.1-3.2 7.1-7.1-3.2-7.1-7.1-7.1"
});

var SvgGlobe = function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "globe",
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default SvgGlobe;